<div class="flex flex-col items-center h-screen">
  <div class="bg-oney shrink-0 w-full flex items-center justify-center h-24">
    <h1 class="text-4xl text-white font-bold text-center">
      Module de test pour le widget Open Banking
    </h1>
  </div>
  <div class="w-full h-full py-9">
    <router-outlet></router-outlet>
  </div>
  <app-notification></app-notification>
</div>
